



















































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import {
  ActiveExperimentGetter,
  Coupon,
  ExperimentGetter,
  FeatureSwitches,
  MobileGetter,
  Optional,
  PaywallPlanObject,
  PaywallPlansInfo,
  PlanType,
  User,
} from 'frontend/types';
import AvailablePlans from 'frontend/views/premium/paywall/AvailablePlans.vue';
import HowPremiumWorks from 'frontend/views/premium/paywall/HowPremiumWorks.vue';
import SubscriptionStartButton from 'frontend/views/premium/paywall/SubscriptionStartButton.vue';
import PaywallFeatures from 'frontend/views/premium/paywall/PaywallFeatures.vue';
import WhatCanILearn from 'frontend/views/premium/paywall/WhatCanILearn.vue';
import CourseContents from 'frontend/views/premium/CourseContents.vue';
import Reviews from 'frontend/views/premium/Reviews.vue';
import CloseButtonBlackSvg from 'frontend/views/premium/paywall/svgs/CloseButtonBlackSvg.vue';
import {
  handleClosedNuxPaywallFromMarketingPage,
  justSignedUpFromMarketingLandingPage,
} from 'frontend/utils/marketing';
import { handleClosedNuxPaywallForReturningUsers } from 'frontend/utils/nux';
import { UserSegmentation } from 'frontend/types/segmentation';
import EmbeddedChargebeeCheckout from 'frontend/views/premium/EmbeddedChargebeeCheckout.vue';
import { embeddedChargebeeCheckoutExperiment } from 'frontend/experiments/embedded_checkout';
import ChevronSvg from 'frontend/views/premium/paywall/svgs/ChevronSvg.vue';
import { safeWindow } from 'frontend/utils/window';
import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';
import {
  getTrialPaywallHeaderExperimentActiveTreatment,
  HEADER_COPY,
  TrialPaywallHeaderCopy,
  TrialPaywallHeaderExperimentTreatment,
} from 'frontend/experiments/trial_paywall';
import { Discount } from 'frontend/types/premium';
import {
  isLegacyDirectTraffic,
  isLegacySeasonal,
  isStudentDiscount,
} from 'frontend/utils/discounts';
import Mobile from 'frontend/views/learningPathV2/Mobile.vue';
import LightningSvg from 'frontend/views/premium/paywall/svgs/LightningSvg.vue';
import TieredPlans from 'frontend/views/premium/paywall/TieredPlans.vue';

@Component({
  components: {
    TieredPlans,
    LightningSvg,
    Mobile,
    ChevronSvg,
    EmbeddedChargebeeCheckout,
    HowPremiumWorks,
    SubscriptionStartButton,
    CourseContents,
    Reviews,
    PaywallFeatures,
    WhatCanILearn,
    CloseButtonBlackSvg,
    AvailablePlans,
    LoadingAnimation,
  },
  computed: {
    ...mapGetters('banner', ['bannerHeight']),
    ...mapGetters('pageHeader', ['isMobile', 'coupon']),
    ...mapGetters('globals', ['inExperiment', 'getActiveTreatment', 'featureSwitches', 'discount']),
    ...mapGetters('paywall', ['canSkipPaywall', 'paywallPlans']),
    ...mapGetters('prepurchaseDestinationUrl', ['prepurchaseDestinationUrl']),
    ...mapGetters('userSegmentations', ['userSegmentations']),
    ...mapState('globals', ['user']),
    ...mapState('paywall', ['paywall_plans', 'nux_goal', 'nux_skills_needed']),
  },
})
export default class NuxPaywall extends Vue {
  @Prop(Boolean) private readonly premiumPage!: boolean | undefined;
  // tslint:disable-next-line:variable-name
  private nux_goal!: string | undefined;
  // tslint:disable-next-line:variable-name
  private skills_needed!: string | undefined;
  // tslint:disable-next-line:variable-name
  private readonly paywall_plans!: PaywallPlanObject[];
  private getActiveTreatment!: ActiveExperimentGetter;
  private readonly paywallPlans!: PaywallPlansInfo;
  private coupon!: Coupon;

  // paywall testimonial experiment is currently closed but we want to open it again soon
  private testimonialExperiment = false;

  private user!: User;
  private inExperiment!: ExperimentGetter;
  private isMobile!: MobileGetter;
  private featureSwitches!: FeatureSwitches;
  private showNext: boolean = false;
  private showFooterButton: boolean = false;
  private canShowEmbeddedCheckout: boolean = false;
  private showTieredPlans: boolean = false;
  private readonly canSkipPaywall!: boolean;
  private userSegmentations?: UserSegmentation[];
  private bannerHeight!: number;
  private prepurchaseDestinationUrl?: string;
  private showPaywallLoader = false;

  // tslint:disable-next-line:variable-name
  private is_discounted!: boolean;
  private readonly discount!: Optional<Discount>;

  private get directTrafficDiscount(): boolean {
    return isLegacyDirectTraffic(this.discount);
  }

  private get seasonalDiscount(): boolean {
    return isLegacySeasonal(this.discount);
  }

  private get isStudentDiscount(): boolean {
    return isStudentDiscount(this.discount);
  }

  private get firstPlan(): PaywallPlanObject {
    return this.paywall_plans[0];
  }

  private redirectToHostedPages(): void {
    window.location.href = this.firstPlan.checkout_url;
  }

  private processPayment(): void {
    this.$emit('processing-payment');
  }

  private get onePageGroup(): boolean {
    return this.user.one_page_trial_paywall;
  }

  private get twoPageGroup(): boolean {
    return !this.user.one_page_trial_paywall;
  }

  private get canSkipNuxPaywall(): boolean {
    if (!this.canSkipPaywall) {
      return false;
    }
    if (this.premiumPage) {
      return false;
    }
    if (this.twoPageGroup) {
      // allow to skip only in second page
      return this.showNext;
    }
    return true;
  }

  private get segmentationAnswers(): string[] {
    return this.userSegmentations?.map(answer => answer.answer_slug) ?? [];
  }

  private get hasTrialOption(): boolean {
    return this.user.has_current_trial_option === true;
  }

  private get potentialBFECandidate(): boolean {
    return (
      this.segmentationAnswers.length > 1 && this.segmentationAnswers.includes('teacher-persona')
    );
  }

  private get trialPaywallHeaderExperimentTreatment(): TrialPaywallHeaderExperimentTreatment {
    const isInTargetSegment =
      this.segmentationAnswers.includes('professional-persona') ||
      this.segmentationAnswers.includes('tech-achiever');

    return isInTargetSegment
      ? getTrialPaywallHeaderExperimentActiveTreatment(this.getActiveTreatment)
      : 'control';
  }

  private get isInCopyExperiment(): boolean {
    return this.trialPaywallHeaderExperimentTreatment !== 'control';
  }

  private get trialPaywallTextCopy(): TrialPaywallHeaderCopy {
    return HEADER_COPY[this.trialPaywallHeaderExperimentTreatment];
  }

  private get allowedtoViewEmbeddedCheckout(): boolean {
    return (
      embeddedChargebeeCheckoutExperiment(this.inExperiment) &&
      Boolean(this.featureSwitches.enable_embedded_checkout)
    );
  }

  private shouldShowEmbeddedCheckout(): void {
    this.scrollToTop();
    if (!this.canShowEmbeddedCheckout) {
      this.canShowEmbeddedCheckout = !this.canShowEmbeddedCheckout;
    }
  }

  private scrollToTop(): void {
    const modal = document.getElementById('top');
    const backButton = document.getElementById('back-button');
    if (backButton && this.premiumPage) {
      const yOffset = -100;
      const win = safeWindow();
      if (win) {
        const y = backButton.getBoundingClientRect().top + win.pageYOffset + yOffset;
        win.scrollTo({ top: y, behavior: 'smooth' });
      }
    } else if (modal) {
      modal.scrollIntoView({ behavior: 'smooth' });
    }
  }

  private goBack(): void {
    this.canShowEmbeddedCheckout = false;
    this.showTieredPlans = false;
  }

  private get inTieredPlanExperiment(): boolean {
    return this.user.show_math_foundations_plan;
  }

  private get moneyBackTextCopyExperiment(): boolean {
    if (this.inTieredPlanExperiment) {
      return false;
    }
    return this.inExperiment('trial_paywall_cta_moneyback_copy_05_23', 'experiment');
  }

  private shouldShowTieredPlans(): void {
    this.scrollToTop();
    if (!this.showTieredPlans && this.inTieredPlanExperiment) {
      this.showTieredPlans = true;
    }
  }

  private mounted() {
    if (!this.$route.query.premium) {
      this.$router.push({
        query: {
          premium: 'true',
          ...this.$route.query,
        },
      });
    }
  }

  private destroyed() {
    if (this.$route.query.premium) {
      const query = Object.assign({}, this.$route.query);
      delete query.premium;
      this.$router.push({ query });
    }
  }

  private handleContinueClick(): void {
    this.$emit('handle-continue-clicked');
    this.showNext = !this.showNext;
    this.showFooterButton = true;
  }

  private annualPlan(plans: object[]) {
    return plans
      .filter((plan: any) => plan.interval === 'year')
      .sort((a: any) => (a.display_type === 'trial_year' ? -1 : 1))[0];
  }

  private async handleClosePaywall() {
    // If mature users are seeing this, then let's send them to logged in home
    if (this.user.is_reactivating) {
      return handleClosedNuxPaywallForReturningUsers(this.$store, this.$router);
    }
    // If landing page user are seeing this on /courses/, they skipped the NUX to get here
    // Let's send them back to the NUX
    if (
      this.$route.name === 'explorations_menu' &&
      justSignedUpFromMarketingLandingPage(this.$route)
    ) {
      return handleClosedNuxPaywallFromMarketingPage(this.$store, this.$router);
    }
    if (this.prepurchaseDestinationUrl && this.$route.path !== this.prepurchaseDestinationUrl) {
      this.showPaywallLoader = true;
      await this.$router.push(this.prepurchaseDestinationUrl);
    } else if (this.bannerHeight > 0) {
      // If banner is visible in paywall, we certainly do not want to show it
      // after the paywall modal is closed.
      this.$store.dispatch('banner/hideBanner');
    }
    this.$emit('close');
  }

  private get shouldShowDiscount(): boolean {
    // Referral discount takes precedence
    if (this.annualPlanIncludesReferralDiscount) {
      return true;
    }
    if (this.seasonalDiscount) {
      return true;
    }
    if (this.directTrafficDiscount) {
      return !!this.discount?.is_visible;
    }
    if (this.isStudentDiscount) {
      return true;
    }
    return this.is_discounted || !!this.paywallPlans.annualPlan?.strikethrough_price;
  }

  private get campaignDiscountOverrideHtml(): string | null {
    if (this.seasonalDiscount || this.isStudentDiscount) {
      return `${this.discount?.name} discount applied`;
    }
    if (this.directTrafficDiscount) {
      return 'Limited time discount applied';
    }
    return null;
  }

  private get discountHtml() {
    if (this.annualPlanIncludesReferralDiscount) {
      return 'Referral discount unlocked!';
    }
    if (this.campaignDiscountOverrideHtml) {
      return this.campaignDiscountOverrideHtml;
    }
    if (this.coupon && this.coupon.code_used_name) {
      return `Discount unlocked for <em>${this.coupon.code_used_name}</em>`;
    }
    if (this.user.days_since_signup !== null && this.user.days_since_signup <= 7) {
      return 'Discount unlocked! Thanks for joining Brilliant.';
    }
    return 'Discount unlocked! Thanks for being active on Brilliant.';
  }

  private get annualPlanIncludesReferralDiscount(): boolean {
    const annualPlanIncludesReferralDiscount =
      this.paywallPlans.annualPlan !== undefined &&
      this.paywallPlans.annualPlan?.includes_referral_discount;
    const annualMathPlanIncludesReferralDiscount =
      this.paywallPlans.annualMathFoundationsPlan !== undefined &&
      this.paywallPlans.annualMathFoundationsPlan?.includes_referral_discount;
    return annualMathPlanIncludesReferralDiscount || annualPlanIncludesReferralDiscount;
  }
}
